import React, { useContext, useMemo } from 'react'
import { Typography } from '@material-ui/core'
import EasyPayPlanRadio from './EasyPayPlanRadio'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { Context } from '../../../Store'
import { BookingContext } from '../../../utils/BookingContext'
import { getCurrency } from '../../../constants'
import { getPricing } from '../../../utils/getPricing'
import { formatToItalianCurrency } from '../../../utils/formatToItalianCurrency'
import { roundToNearestTenCents } from '../../../utils/roundToNearstTenCents'

function EasyPayPlanWithoutOptionCard({ checked, onChange }) {
  const { t } = useTranslation()
  const toCurrency = (amount) => formatToItalianCurrency(roundToNearestTenCents(amount))
  const [state] = useContext(Context)
  const { hasCounteroffer } = useContext(BookingContext)
  const { value: propertyCurrency } = getCurrency(state.property.currency)
  const { upfrontFee, deposit } = useMemo(() => getPricing(state.property, state.booking, hasCounteroffer), [
    state.property,
    state.booking,
    hasCounteroffer,
  ])
  return (
    <div
      style={{
        height: '100%', 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        borderRadius: 12,
      }}
      onClick={onChange}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F1F1F1',
          padding: '12px 0px',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        <EasyPayPlanRadio checked={checked} />
        <Typography
          style={{
            fontWeight: 700,
            fontSize: 16,
            color: '#4F4F4F',
            marginLeft: 6,
            marginBottom: 0,
            textAlign: 'center',
          }}
        >
          {t('easyPayPlan.bookWithoutEasyPayPlan.title')}
        </Typography>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px 8px',
          flexGrow: 1,
        }}
      >
        <Typography style={{ fontSize: 16, fontWeight: 400, color: '#394555', marginBottom: 0, textAlign: 'center' }}>
          {t('easyPayPlan.bookWithoutEasyPayPlan.subtitle')}
        </Typography>
        <Typography style={{ fontSize: 24, fontWeight: 700, color: '#333333', marginBottom: 0, textAlign: 'center' }}>
          {toCurrency(deposit + upfrontFee)}{propertyCurrency}
        </Typography>
        <Typography style={{ fontSize: 11, fontWeight: 400, color: '#394555', marginBottom: 0 , textAlign: 'center' }}>
          <Trans
            i18nKey="easyPayPlan.bookWithoutEasyPayPlan.disclaimer"
            values={{
              commission: toCurrency(upfrontFee),
              deposit: toCurrency(deposit),
              upfront_total: toCurrency(upfrontFee + deposit),
              currency: propertyCurrency,
            }}
          />
        </Typography>
      </div>
    </div>
  )
}

EasyPayPlanWithoutOptionCard.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default EasyPayPlanWithoutOptionCard
